import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchPostBySlug } from '../../redux/slices/Blog/blogSlice';
import { Helmet } from 'react-helmet-async';
import DOMPurify from 'dompurify'; // defense in depth: posts are also sanitized by the API

const BlogPost = () => {
  const { slug } = useParams();
  const { t, i18n } = useTranslation('common');
  const dispatch = useDispatch();
  const { currentPost, isLoading } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(fetchPostBySlug({ slug, lang: i18n.language }));
  }, [dispatch, slug, i18n.language]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
      </div>
    );
  }

  if (!currentPost) {
    return <div className="text-center py-12">{t('blog.postNotFound')}</div>;
  }

  return (
    <>
      <Helmet>
        <title>{currentPost.title} | Hotel Macarios</title>
        <meta name="description" content={currentPost.content.substring(0, 160)} />
        <link rel="canonical" href={`https://www.hotelmacarios.com.mx/blog/${currentPost.slug}`} />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 py-12">
        {currentPost.image && <img src={currentPost.image} alt={currentPost.title} className="w-full h-64 object-cover rounded-lg mb-6" />}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">{currentPost.title}</h1>
        <p className="text-gray-500 text-sm mb-4">{new Date(currentPost.publishedAt).toLocaleDateString()} • {currentPost.author?.fullname}</p>
        <div className="prose prose-lg max-w-none text-gray-700" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(currentPost.content) }} />
      </div>
    </>
  );
};
export default BlogPost;